import { AxiosResponse } from "axios";
import API from "../api";
import { MemberCertification  } from "../models/members/member.certification";

import BaseService from "./_base.service";

const endpoint = "certifications";

const MemberCertificationService = {
  ...BaseService<MemberCertification>({ endpoint }),
  async approveCertifaction(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/approve/${id}`);
  }
};

export default MemberCertificationService;
